import { render, staticRenderFns } from "./Mannequin.vue?vue&type=template&id=1915687a"
import script from "./Mannequin.vue?vue&type=script&lang=js"
export * from "./Mannequin.vue?vue&type=script&lang=js"
import style0 from "./Mannequin.vue?vue&type=style&index=0&id=1915687a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports